import React from "react"
import '../../styles/FolderCard.css';
import {angularRouterHost} from "../utils/angularManagerUtils";
import Dotdotdot from "react-dotdotdot";
import {buildRoute} from "../utils/routerUtils";
import {ROUTES} from "../utils/constants";
import {Link} from "react-router-dom";


export interface ProjectFolderProps {
  id: string;
  name: string;
  productCount: number;
}

const getProductCountVerbiage = (productCount: number) => {
  if (!productCount) return '';
  else {
    return productCount + (productCount > 1 ? ' Products' : ' Product');
  }
}

const onClick = (id: string) => {
  window.location.href = `${angularRouterHost()}${id}`;
}

const ProjectFolder = (props: ProjectFolderProps) => {
  if (!props.id) {
     return (
       <div>
         <div className="folder-card-vstui">
           <div className="folder-card-folder nil-folder">
           </div>
         </div>
       </div>
     )
  }

  return (
      <div id={props.id}>
        <div className="folder-card-vstui">
          <Link to={buildRoute(ROUTES.PRODUCTS, {":projectId": props.id})} className={"folder-card-folder" + (!props.productCount ? ' empty-folder': '')}>
            <div className ="folder-card-text-area">
              <div title={props.name} className="folder-card-name">
                <Dotdotdot clamp={2}>
                  {props.name}
                </Dotdotdot>
              </div>
              <div className="folder-card-product-count">{getProductCountVerbiage(props.productCount)}</div>
            </div>
          </Link>
        </div>
      </div>
  )
}

export default ProjectFolder;
